<template>
  <div id="contact">
    <div class="row mt-md-5 text-center">
      <div class="col-md-12">
        <img src="/static/images/contact/1.png" class="img-fluid" alt="コアラくんの画像">
      </div>
      <div class="col-md-12 mb-4">
        <p class="mail"><a href="mailto:koarakun@ohisamak-ehonya.com">koarakun@ohisamak-ehonya.com</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    title: "お問い合わせ",
    data() {
      return {}
    },
    mounted: function() {
      this.$nextTick(function () {
        try {
          FONTPLUS.reload();
        } catch (error) {
          console.log(error.message);
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue